import React, { useState, useEffect } from "react";

const products = [
  {
    id: "2",
    proName: "FLYIN MACHINE",
    proImg: "/assets/Men/products/jean-1.jpg",
    proDesc: "",
    proPrice: "50",
    category: "men",
    proSelect: "Jeans",
    block2: "/assets/Men/products/menCol/jean/jean-2.jpg",
    block3: "/assets/Men/products/menCol/jean/jean-3.jpg",
    block4: "/assets/Men/products/menCol/jean/jean-4.jpg",
    block5: "/assets/Men/products/menCol/jean/jean-5.jpg"
  },
  {
    id: "3",
    proName: "JACK & JONES",
    proImg: "/assets/Men/products/mcg-1.jpg",
    proDesc: "",
    proPrice: "40",
    category: "men",
    proSelect: "Cargo's",
    block2: "/assets/Men/products/menCol/mcg/mcg-2.jpg",
    block3: "/assets/Men/products/menCol/mcg/mcg-3.jpg",
    block4: "/assets/Men/products/menCol/mcg/mcg-4.jpg",
    block5: "/assets/Men/products/menCol/mcg/mcg-5.jpg"
  },
  {
    id: "4",
    proName: "FAREN HEIT",
    proImg: "/assets/Men/products/mcasual-1.jpg",
    proDesc: "",
    proPrice: "30",
    category: "men",
    proSelect: "Men Casuals",
    block2: "/assets/Men/products/menCol/mcasual/mcasual-2.jpg",
    block3: "/assets/Men/products/menCol/mcasual/mcasual-3.jpg",
    block4: "/assets/Men/products/menCol/mcasual/mcasual-4.jpg",
    block5: "/assets/Men/products/menCol/mcasual/mcasual-5.jpg"
  }
];

const AddToCart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("cartItems"));
    if (items) {
      setCartItems(items);
      setCartCount(items.length);
    }
  }, []);

  const handleAddToCart = (item) => {
    const updatedCartItems = [...cartItems, item];
    setCartItems(updatedCartItems);
    localStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
    setCartCount(updatedCartItems.length);
  };

  return (
    <>
      <h1>Add to Cart Page</h1>
      <ul>
        {products.map((item) => (
          <li key={item.id}>
            <img src={item.proImg} alt={item.proName} />
            <h2>{item.proName}</h2>
            <p>{item.proPrice}</p>
            <button onClick={() => handleAddToCart(item)}>Add to Cart</button>
          </li>
        ))}
      </ul>
      <p>Items in Cart: {cartCount}</p>
    </>
  );
};

export default AddToCart;
